var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlSecurePaymentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Card, Bank Card, Payment "
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M1.26172 19.4057V3.57031H20.7638V19.4057H1.26172ZM3.41589 7.99323H18.5867V5.7474H3.41589V7.99323ZM3.41589 10.9495V17.2516H18.5867V10.9495H3.41589Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlSecurePaymentIcon);
export default __webpack_public_path__ + "static/media/bl-secure-payment-icon.0a7c153082cf8e085b2f368bb2728de8.svg";
export { ForwardRef as ReactComponent };